module.exports = __webpack_public_path__ + "static/media/funitygame5.fc625b4f.png";